import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import * as UserActions from '../../actions/user_actions';
import * as SettingScreen from '../../actions/settingScreen_actions';
import * as FacilitiesActions from '../../actions/facilities_actions';
import { bindActionCreators } from 'redux';
import Modal from 'react-modal';
import { ModalDialog } from '../modal_dialog';
import { ModalDialogCommon } from '../modal_dialog_common';
import { validate } from '../../validations';
import InputMask from 'react-input-mask';

let ProfileSetting = React.createClass({
    getInitialState() {
        return {
            showPasswordModal: false,
            isVerifyPasswordSubmitted: false,
            isProfileDataSubmitted: null,
            invalidPasswordErrorMsg: null,
            invalidOTPErrorMsg: null,
            errorMessage: null,

            oKModelMessage: null,

            mobileCssClass: "inputText",
            zipCodeCssClass: "inputText",
            isSubmitEnabled: null,
            isEditMode: null,

            userProfileData: null,
            fileUploaded: null,
            dialog: false,
            profileImage: null
        }
    },
    componentWillMount() {
        this.props.LoggedInUserDetails && this.props.LoggedInUserDetails.data ? this.props.LoggedInUserDetails.data.status = null : '';
        var id = this.props.LogingDetails.data.id;

        let fc_id = this.props.UserDetails.selectedUserRoleID === 1 ? 0 : this.props.UserDetails.selectdUserFacilityID;

        this.props.Dispatch(FacilitiesActions.getAdminUserById(id + "/" + fc_id));

    },

    verifyPassword() {
        if (this.refs.oldPassword.value != "" && this.refs.otp.value != '') {
            var PassCheck = {
                "id": this.props.LogingDetails.data.id,
                "uniqueKey": this.props.LogingDetails.data.uniqueKey,
                "password": this.refs.oldPassword.value
            }
            this.setState({
                invalidPasswordErrorMsg: null,
                isVerifyPasswordSubmitted: true,
            });
            this.props.Dispatch(SettingScreen.verifyPass(PassCheck));

            this.props.Dispatch(SettingScreen.verifyOTP({
                "otp": this.refs.otp.value,
                "id": this.props.LogingDetails.data.id,
                "deviceKey": this.props.LogingDetails.data.deviceKey
            }))
        }
        else {
            if (this.refs.oldPassword.value === "") {
                this.setState({
                    isVerifyPasswordSubmitted: null,
                    invalidPasswordErrorMsg: 'Please enter valid password.',
                });
            }
            if (this.refs.otp.value === '') {
                this.setState({
                    isVerifyPasswordSubmitted: null,
                    invalidOTPErrorMsg: 'Please enter valid OTP.',
                });
            }

        }

    },
    removeCancelPrompt() {
        this.setState({
            showPasswordModal: false,
            invalidPasswordErrorMsg: null,
            invalidOTPErrorMsg: null
        });
    },
    componentWillReceiveProps(nextProps) {

        if (nextProps.LoggedInUserDetails.data) {
            this.setState({ userProfileData: nextProps.LoggedInUserDetails.data, dialog: true })
        }

        // Password Verification Response
        if (this.state.isVerifyPasswordSubmitted && nextProps.VerifyPasswordResponse && nextProps.UserDetails.OTPResponse) {
            if (nextProps.VerifyPasswordResponse.status == 200 && nextProps.UserDetails.OTPResponse.status == 200) {
                nextProps.VerifyPasswordResponse.status = "";
                this.setState({
                    showPasswordModal: false,
                    invalidPasswordErrorMsg: null,
                });
                var data = {
                    "id": this.props.LogingDetails.data.id,

                    "address": {
                        "city": this.refs.city.value,
                        "country": this.refs.country.value,
                        "street": this.refs.street.value,
                        "state": this.refs.state.value,
                        "zipCode": this.refs.zipcode.state.value,
                    },
                    // "email": this.refs.email.value,
                    "mobile": this.refs.mobile.state.value.replace(/ /g, ""),
                    "firstName": this.refs.firstName.value,
                    "lastName": this.refs.lastName.value,

                    "uniqueKey": this.props.LogingDetails.data.uniqueKey,
                    "role": { "id": this.props.LogingDetails.data.roleId }
                }

                this.props.Dispatch(SettingScreen.profileUpdate(data));
                this.setState({ isProfileDataSubmitted: true });

            } else {

                if (nextProps.VerifyPasswordResponse.status !== 200) {
                    this.setState({
                        invalidPasswordErrorMsg: nextProps.VerifyPasswordResponse.message
                    });
                }
                if (nextProps.UserDetails.OTPResponse.status !== 200) {
                    this.setState({
                        invalidOTPErrorMsg: nextProps.UserDetails.OTPResponse.message
                    });
                }
            }

            this.setState({
                isVerifyPasswordSubmitted: null,
            });
        }

        // Profile Update Response
        if (this.state.isProfileDataSubmitted) {
            this.props.Dispatch(UserActions.uploadUserProfileImage(this.state.profileImage, 'USER', this.props.LogingDetails.data.id));
            this.setState({ isSubmitEnabled: null });
            if (nextProps.ProfileUpdateResponse && nextProps.ProfileUpdateResponse.status == 200) {
                this.setState({ isEditMode: null });
                nextProps.ProfileUpdateResponse.status = '';
                let fc_id = this.props.UserDetails.selectedUserRoleID === 1 ? 0 : this.props.UserDetails.selectdUserFacilityID;

                this.props.Dispatch(FacilitiesActions.getAdminUserById(this.props.LogingDetails.data.id + "/" + fc_id));
                this.setState({ oKModelMessage: "Your information has been updated successfully." });
            } else {
                if (nextProps.ProfileUpdateResponse && nextProps.ProfileUpdateResponse.status != 200) {
                    this.setState({
                        oKModelMessage: nextProps.ProfileUpdateResponse.message
                    })
                }
            }

            this.setState({ isProfileDataSubmitted: null });
        }

    },
    email_validate(event) {
        let email = event.target.value;
        let isEmailTrue = validate.email(email);
        isEmailTrue ? event.target.className = 'inputText' : event.target.className = 'inputText error';
    },
    phon_validate(event) {
        let mobile = event.target.value;
        let isMobileTrue = validate.phone(mobile);
        isMobileTrue ? event.target.className = 'inputText' : event.target.className = 'inputText error';
    },
    zipcode_validate(event) {
        let zipcode = event.target.value;
        let iszipcodeTrue = validate.zipCode(zipcode);
        iszipcodeTrue ? event.target.className = 'inputText' : event.target.className = 'inputText error';
    },

    no_empty(event) {
        let value = event.target.value;
        let isInputvalueTrue = validate.notEmpty(value);
        isInputvalueTrue ? event.target.className = 'inputText' : event.target.className = 'inputText error';
    },

    remove_error(event) {
        event.target.className = 'inputText';

    },

    clearInput() {
        this.setState({
            invalidPasswordErrorMsg: null, invalidOTPErrorMsg: null
        })
    },

    handleKeyPress(e) {
        if (e.key === 'Enter') {
            this.verifyPassword();
        }
    },
    Update() {
        // To make the fields editable
        if (!this.state.isEditMode) {
            this.setState({ isEditMode: true });
            return;
        }
        if (this.state.isEditMode && !this.state.isSubmitEnabled) {
            this.setState({ oKModelMessage: "Please update any field to save." });
            return;
        }
        // this.setState({ isEditMode: null });

        // FirstName
        let isValidFName = validate.name(this.refs.firstName);
        isValidFName ? this.refs.firstName.className = 'inputText' : this.refs.firstName.className = 'inputText error';
        // LastName
        let isValidLName = validate.name(this.refs.lastName);
        isValidLName ? this.refs.lastName.className = 'inputText' : this.refs.lastName.className = 'inputText error';
        // Mobile
        let isValidMobile = validate.phone(this.refs.mobile.state.value);
        isValidMobile ? this.setState({ mobileCssClass: 'inputText' }) : this.setState({ mobileCssClass: 'inputText error' });
        // Email
        let isValidEmail = validate.email(this.refs.email.value);
        isValidEmail ? this.refs.email.className = 'inputText' : this.refs.email.className = 'inputText error';
        // Street
        let isValidStreet = validate.name(this.refs.street);
        isValidStreet ? this.refs.street.className = 'inputText' : this.refs.street.className = 'inputText error';
        // city
        let isValidCity = validate.name(this.refs.city);
        isValidCity ? this.refs.city.className = 'inputText' : this.refs.city.className = 'inputText error';
        //state
        let isValidState = validate.name(this.refs.state);
        isValidState ? this.refs.state.className = 'inputText' : this.refs.state.className = 'inputText error';
        // Country
        let isValidCountry = validate.name(this.refs.country);
        isValidCountry ? this.refs.country.className = 'inputText' : this.refs.country.className = 'inputText error';
        // zipcode
        let isValidZipcode = validate.zipCode(this.refs.zipcode.state.value);
        isValidZipcode ? this.setState({ zipCodeCssClass: 'inputText' }) : this.setState({ zipCodeCssClass: 'inputText error' });

        if (this.refs.firstName.value.trim().length === 0 || this.refs.lastName.value.trim().length === 0 || this.refs.street.value.trim().length === 0 || this.refs.city.value.trim().length === 0 || this.refs.state.value.trim().length === 0 || this.refs.country.value.trim().length === 0 || this.refs.zipcode.state.value.length === 0 || this.refs.mobile.state.value.length === 0) {
            this.setState({
                errorMessage: "Please correct the highlighted fields."
            })
            return false;
        }
        if (isValidFName && isValidLName && isValidMobile && isValidEmail && isValidStreet && isValidCity && isValidState && isValidCountry && isValidZipcode) {
            this.setState({
                errorMessage: null,
                showPasswordModal: true,
            });
            this.props.Dispatch(SettingScreen.getOTP({
                id: this.props.LogingDetails.data.id,
                email: this.props.LogingDetails.data.email,
                "uniqueKey": this.props.LogingDetails.data.uniqueKey,
                "deviceKey": this.props.LogingDetails.data.deviceKey
            }));

        }
        else {
            this.setState({
                errorMessage: "Please enter necessary fields to proceed."
            })
        }

    },

    closeOkModal() {
        this.setState({ oKModelMessage: null });
    },
    enableSubmit() {
        this.setState({ isSubmitEnabled: true });
        this.setState({ isEditMode: true });
    },
    removeCancelPrompt() {
        this.setState({ showPasswordModal: false, invalidOTPErrorMsg: null, invalidPasswordErrorMsg: null })
        this.props.Dispatch(SettingScreen.resetOTPData());
    },
    Cancel() {
        this.refs.firstName.value = this.state.userProfileData.firstName;
        this.refs.lastName.value = this.state.userProfileData.lastName;
        this.refs.street.value = this.state.userProfileData.address.street;
        this.refs.city.value = this.state.userProfileData.address.city;
        this.refs.state.value = this.state.userProfileData.address.state;
        this.refs.country.value = this.state.userProfileData.address.country;
        this.refs.firstName.className = 'inputText';
        this.refs.lastName.className = 'inputText';
        this.refs.firstName.className = 'inputText';
        this.refs.street.className = 'inputText';
        this.refs.city.className = 'inputText';
        this.refs.state.className = 'inputText';
        this.refs.country.className = 'inputText';
    },
    uploadProfileImage(e) {

        // if User doesn't select(if he click on cancle) any image
        //To check if user upload any file
        if (e.target.files.length === 0) {
            return;
        }

        var fuData = e.target.files[0];
        var FileUploadPath = fuData.name;
        var size = fuData.size;

        //To check the uploaded file is an image
        var Extension = FileUploadPath.substring(FileUploadPath.lastIndexOf('.') + 1).toLowerCase();
        if (Extension == "png" || Extension == "jpeg" || Extension == "jpg") {

            if (size < 2097152) {
                var files = e.target.files || e.dataTransfer.files;
                var imageData = new FormData();
                let file = files[0];
                this.setState({ fileUploaded: file.name });
                imageData.append("file", e.target.files[0]);
                this.setState({ isSubmitEnabled: true, isEditMode: true, profileImage: imageData })
            }
            else {
                e.target.value = "";
                this.setState({ Okmessage: "Please select an image that is less than 2MB.", dialog: false });
            }

        }
        else {
            this.setState({
                Okmessage: "Only photos with extension .png, .jpg, .jpeg are allowed.",
                dialog: false
            })
        }
    },
    closebox() {
        this.setState({ Okmessage: false });
    },
    togglePassword() {
        var pwd = document.getElementById("password");
        pwd.type === "password" ? (pwd.type = "text") : (pwd.type = "password");
    },
    render() {
        var profileData = this.state.userProfileData;
        return (

            <div role="tabpanel" className="tab-pane active" id="unique">
                <div className="create-facility">
                    {profileData &&
                        <div className="row">

                            <div className="col-xs-6 no-padding update-profile">
                                <div className="input-group input-field">
                                    <input type="text" className="inputText" tabIndex="1" ref="firstName" defaultValue={profileData.firstName} onFocus={this.remove_error} onChange={this.enableSubmit} onBlur={this.no_empty} required />
                                    <span className="floating-label">First Name</span>
                                </div>
                                <div className="input-group input-field">
                                    <input type="text" className="inputText" tabIndex="2" ref="lastName" defaultValue={profileData.lastName} onFocus={this.remove_error} onChange={this.enableSubmit} onBlur={this.no_empty} required />
                                    <span className="floating-label">Last Name</span>

                                </div>
                                <div className="input-group input-field readonly" >
                                    <input type="text" className="inputText" tabIndex="-1" ref="email" defaultValue={profileData.email} onFocus={this.remove_error} onBlur={this.email_validate} required />
                                    <span className="floating-label">Email</span>

                                </div>
                                <div className="input-group input-field">
                                    <InputMask type="text" className={this.state.mobileCssClass} tabIndex="3" ref="mobile" defaultValue={profileData.mobile} onFocus={this.remove_error} onChange={this.enableSubmit} onBlur={this.phon_validate} required mask="999 999 9999" maskChar={null} ></InputMask>
                                    <span className="floating-label">Phone</span>

                                </div>


                                <div className="input-group input-field">
                                    <div className="facility-upload">
                                        <p>
                                            <label className="uploadBtn gray-button" htmlFor="upload">Upload Profile image</label>
                                            <input type="file" id="upload" ref="profileImageUrl" onChange={this.uploadProfileImage} required />
                                            <span>{this.state.fileUploaded && this.state.fileUploaded} </span>
                                        </p>
                                    </div>
                                </div>

                            </div>

                            <div className="col-xs-6 no-padding update-profile">
                                <div className="input-group input-field">
                                    <input type="text" className="inputText" tabIndex="4" ref="street" defaultValue={profileData.address && profileData.address.street ? profileData.address.street : ""} onFocus={this.remove_error} onChange={this.enableSubmit} onBlur={this.no_empty} required />
                                    <span className="floating-label">Street</span>
                                </div>
                                <div className="input-group input-field">
                                    <input type="text" className="inputText" ref="city" tabIndex="5" defaultValue={profileData.address ? profileData.address.city : ""} onFocus={this.remove_error} onChange={this.enableSubmit} onBlur={this.no_empty} required />
                                    <span className="floating-label">City</span>
                                </div>
                                <div className="input-group input-field">
                                    <input type="text" className="inputText" ref="state" tabIndex="6" defaultValue={profileData.address ? profileData.address.state : ""} onFocus={this.remove_error} onChange={this.enableSubmit} onBlur={this.no_empty} required />
                                    <span className="floating-label">State</span>
                                </div>
                                <div className="input-group input-field">
                                    <input type="text" className="inputText" tabIndex="7" ref="country" defaultValue={profileData.address ? profileData.address.country : ""} onFocus={this.remove_error} onChange={this.enableSubmit} onBlur={this.no_empty} required />
                                    <span className="floating-label">Country</span>
                                </div>
                                <div className="input-group input-field">
                                    <InputMask type="text" className={this.state.zipCodeCssClass} tabIndex="8" ref="zipcode" defaultValue={profileData.address ? profileData.address.zipCode : ""} onFocus={this.remove_error} onChange={this.enableSubmit} onBlur={this.zipcode_validate} required mask="99999" maskChar={null}></InputMask>
                                    <span className="floating-label">Zip</span>
                                </div>
                                <div className="input-group input-field">
                                    <input type="text" className="inputText" defaultValue={profileData.facilities && profileData.facilities.length ? profileData.facilities[0].role.name : ""} disabled />
                                    <span className="floating-label">Role</span>
                                </div>
                            </div>

                        </div>
                    }

                    {this.state.errorMessage &&
                        <div className="error-message">
                            <span className="red-color">{this.state.errorMessage} </span>
                        </div>}
                    {this.props.LoggedInUserDetails && this.props.LoggedInUserDetails.data &&
                        <div className="row">

                            <div className="col-xs-12 no-padding recovery-buttons">

                                <button className="save-button gray-button" onClick={this.Update}>{this.state.isEditMode ? "SAVE" : "EDIT"}</button>
                                <button className="save-button cancel-btn" onClick={this.Cancel}>Cancel</button>

                            </div>

                        </div>
                    }


                </div >
                <Modal isOpen={this.state.showPasswordModal} className='delete-prompt modalPopup logout' contentLabel='modalPopup'>
                    <div className="popup-content profile text-center">
                        <p className='main_header'>
                            Please enter your password and otp sent to your mail to proceed.
                         </p>
                        <div>
                            <div className="input-group">
                                <div className="input-group">
                                    <input type="password" ref="oldPassword" className="inputText" id="password" onChange={this.clearInput} onKeyPress={this.handleKeyPress} required />
                                    <span className="floating-label">PASSWORD</span>
                                    <img
                                        src={require("./../../images/eye-open.png")}
                                        className="eye-icon"
                                        onClick={() => {
                                            this.togglePassword();
                                        }}
                                    />
                                </div>
                                {this.state.invalidPasswordErrorMsg &&
                                    <div className="error-message">
                                        <span className="red-color">{this.state.invalidPasswordErrorMsg} </span>
                                    </div>}
                                <div className="input-group">
                                    <input type='text' ref='otp' className="inputText" onKeyPress={this.handleKeyPress} required maxLength={4} />
                                    <span className="floating-label">OTP</span>
                                    {this.state.invalidOTPErrorMsg &&
                                        <div className="error-message">
                                            <span className="red-color">{this.state.invalidOTPErrorMsg} </span>
                                        </div>}
                                </div>
                            </div>
                            <input type='button' value='SUBMIT' className='button button-primary btn-submit gray-button' ref='deleteBtn' onClick={this.verifyPassword} />
                            <input type='button' value='CANCEL' className='button button-primary btn-submit white-button' ref='deleteCancelBtn' onClick={this.removeCancelPrompt} />
                        </div>
                    </div>
                </Modal>
                {this.state.oKModelMessage && <ModalDialogCommon message={this.state.oKModelMessage} action={this.closeOkModal} />}
                <div className="row">
                    <div className="col-xs-12 no-padding">
                        <div> {this.state.Okmessage && <ModalDialogCommon message={this.state.Okmessage} action={this.closebox} />}</div>
                    </div>
                </div>
            </div>
        );
    }
});

let mapStateToProps = (state) => {
    return {
        // To use basic details like id to get all info of Logged in user details.
        LogingDetails: state.User.loginData,
        UserDetails: state.User,
        // To show Profile data of Logged in User.
        LoggedInUserDetails: state.Facilites.FaciliteAdminUser,

        ProfileUpdateResponse: state.Setting.profileUpdate,
        VerifyPasswordResponse: state.Setting.verification,
        OTPGetData: state.Setting.otpGetData
    };
};

let mapDispatchToProps = (dispatch) => ({
    UserActions: bindActionCreators(UserActions, dispatch),
    SettingScreen: bindActionCreators(SettingScreen, dispatch),
    FacilitiesActions: bindActionCreators(FacilitiesActions, dispatch),
    Dispatch: dispatch
});
export default connect(mapStateToProps,
    mapDispatchToProps)(withRouter(ProfileSetting));



/** WEBPACK FOOTER **
 ** ./src/components/settingsScreen/profileSetting.js
 **/